export default function KPICard({ label, value, unit, sub, color = 'var(--accent)', icon: Icon, trend }) {
  return (
    <div className="card" style={{ position: 'relative', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: 2,
        background: `linear-gradient(90deg, ${color}, transparent)`
      }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <p style={{ fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>{label}</p>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
            <span style={{ fontSize: 28, fontWeight: 700, fontFamily: 'var(--mono)', color }}>{value}</span>
            {unit && <span style={{ fontSize: 13, color: 'var(--text2)' }}>{unit}</span>}
          </div>
          {sub && <p style={{ fontSize: 12, color: 'var(--text2)', marginTop: 4 }}>{sub}</p>}
          {trend && <p style={{ fontSize: 11, color: trend > 0 ? 'var(--success)' : 'var(--danger)', marginTop: 4 }}>
            {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}% vs last week
          </p>}
        </div>
        {Icon && (
          <div style={{
            width: 38, height: 38, borderRadius: 10,
            background: `${color}15`, border: `1px solid ${color}30`,
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
          }}>
            <Icon size={18} color={color} />
          </div>
        )}
      </div>
    </div>
  );
}
